'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTheme = exports.darken = exports.transparentize = exports.ThemeProvider = exports.styled = exports.keyframes = exports.injectGlobal = exports.css = exports.constants = exports.classnames = undefined;

var _reactEmotion = require('react-emotion');

var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

var _emotion = require('emotion');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _emotionTheming = require('emotion-theming');

var _polished = require('polished');

var _constants = require('./constants');

var constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://medium.com/webpack/webpack-4-import-and-commonjs-d619d626b655
function interpolateDefaultRequire(m) {
  try {
    return m && m.default ? m.default : m;
  } catch (e) {
    return m;
  }
}

var styled = interpolateDefaultRequire(_reactEmotion2.default);

/**
 * Wraps 3rd party libraries, incase we need to replace emotion, or classnames in the future
*/
exports.classnames = _classnames2.default;
exports.constants = constants;
exports.css = _reactEmotion.css;
exports.injectGlobal = _emotion.injectGlobal;
exports.keyframes = _reactEmotion.keyframes;
exports.styled = styled;
exports.ThemeProvider = _emotionTheming.ThemeProvider;
exports.transparentize = _polished.transparentize;
exports.darken = _polished.darken;
exports.withTheme = _emotionTheming.withTheme;